import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-electric/30 bg-panel py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-39" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-40" data-mp="xu0oy2i5bhfr">
        <h2 id="closing-title" className="text-balance text-center text-4xl font-bold leading-[1.05] tracking-tight text-white sm:text-5xl" data-id="element-41" data-mp="xs7fygk28l4l">
          Stop Improvising. <span className="text-gold" data-id="element-42" data-mp="17sgazr2bg0ie">Start Preparing.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-43" data-mp="1ljbppjzhxbtw">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-electric bg-navy/60 px-4 py-3 text-sm font-semibold text-white" data-id="element-44" data-mp="1hhq67fsghzaq" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-45" data-mp="27c8cwsxgt0jq" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}